<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-alert"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="text-title">{{lbl.modal_consent_age.title}}</div>
                    <div class="text-msg" v-html="lbl.modal_consent_age.msg">
                    </div>
                    <div class="box-consent" @click="checkAge()">
                        <div class="bg-checkbox" :class="{'active': isAcceptAge}"></div>
                        <div class="text">{{lbl.modal_consent_age.msg_detail}}</div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-confirm" v-if="isAcceptAge" @click="clickOk()">
                        <div class="btn-txt">
                            {{lbl.modal_consent_age.btn}}
                        </div>
                    </div>
                    <div class="btn-confirm disabled" disabled v-else>
                        <div class="btn-txt">
                            {{lbl.modal_consent_age.btn}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//helper
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';
export default {
    name: 'AgeConsentAlertModal',
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            title: '',
            message: '',
            btnOk: '',
            tag: '',
            theme: '',
            busModal: null,
            lbl: Locale.getLbl(),
            checkboxConsent: false,
            isAcceptAge: false,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickOk: function(){
            this.hide();
            this.controller.sendCallbackOk(this.isAcceptAge);
        },
        close: function () {
            this.hide();
        },
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.theme = config.theme;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        },
        checkAge: function () {
            this.isAcceptAge = !this.isAcceptAge;
            // this.onValidateForm();
        },
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
@import "@/style/base/baseDisplay.scss";
.modal-alert {
    .modal-body{
        .modal-base-head{
            .icon-check{
                padding: 40px 0 20px;
                img{
                    width: 62px;
                }
            }
        }

        .modal-base-body{

            font-size: 1.25rem;

            @include mini-mobile(){
                font-size: 1.1rem;
            }

            .text-title{
                font-family: $medium;
                color: $dark-blue;
                padding-top: 30px;
            }

            .text-msg{
                font-family: $regular;
                color: $bright-gray;
                padding: 15px 0;
            }
            .box-consent {
                @extend %display-flex;
                justify-content: center;
                .bg-checkbox {
                    background-image: url('../../../../assets/icon/regis_iconcheck_inactive@2x.png');
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: 100%;
                    flex: 0 0 24px;
                    width: 24px;
                    margin-right: 10px;
                    margin-bottom: 20px;
                    img {
                        width: 24px;
                    }

                    &.active {
                        background-image: url('../../../../assets/icon/regis_iconcheck_active@2x.png');
                    }
                }
                .text{
                    font-family: $regular;
                    margin-bottom: 20px;
                    color: $pink;
                    font-size: 1rem;
                }
            }
        }

        .btn-confirm{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;
        }
        .btn-dis{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;
        }
    }
}
</style>
<style lang="scss">
.modal-alert{
    .modal-body{
        width: 100%;
        padding: 0 20px;
        margin: auto;
        text-align: center;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>
